import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette:{
        secondary:{
            main:"#15c630",
        },
    }
})